module.exports = __webpack_public_path__ + "static/media/services-submenu-health-protocal.c21b4da0.png";